import Icon from 'flow/components/ui-components/Icon';
import Tooltip from 'flow/components/ui-components/Tooltip';
import useAppContext from 'flow/hooks/useAppContext';

const Information = () => {
    const { i18next } = useAppContext();
    return (
        <Tooltip
            placement="bottom-end"
            label={i18next.t('central_switch.missed_calls_from_queues.info')}
        >
            <Icon iconKey="infoOutlinedIcon" className="size-4 text-gray-300" />
        </Tooltip>
    );
};

export default Information;
